// Third Party Imports
import React from 'react';
import MultipleAccountsButton from '../Button/MultipleAccountsButton';

// Relative Imports
import './MultipleAccountsContinueButtonHolder.less';
import { getCurrencySymbol } from '../../utils/constants';

export default class MultipleAccountsContinueButtonHolder extends React.Component {
    constructor(props) {
        super(props);
    }

    displayCurrencyList(currencyList) {
        return currencyList.map((currency, index) => (
            <span key={currency}>
                {currency} {getCurrencySymbol(currency) || ''}{index < currencyList.length - 1 && <span>{' or '}</span>}
            </span>
        ));
    }

    renderContinueButton() {
        const {
            enableContinueButton,
            handleContinueButtonClick,
            continueButtonId,
            data,
            brandImage,
            flagImage
        } = this.props;

        return (
            <MultipleAccountsButton
                brandImage={brandImage}
                flagImage={flagImage}
                language={data.locale}
                domain={data.domain}
                currencies={this.displayCurrencyList(data.currencies)}
                selectAccount={event => handleContinueButtonClick(event, data)}
                buttonId={continueButtonId}
                enableButton={enableContinueButton}
            />
        )
    }

    render() {
        return (
            <div className="multiple-accounts-continue-button-holder">
                {this.renderContinueButton()}
            </div>
        );
    }
}
